import React, { Component } from "react";
import { PROGRESS_BAR, STATUS, STEPS } from "../constants";

export default class ProgressBar extends Component {
  state = {
    width: PROGRESS_BAR.INITIAL_WIDTH,
    stepCount: PROGRESS_BAR.STEP_COUNT,
  };

  render() {
    const { values } = this.props;

    // console.log("licount", liCount.length);

    if (values.status === STATUS.FOUND_ADVISOR) {
      var styleVariable =
        100 / this.state.stepCount - PROGRESS_BAR.WIDTH_ADJUSTMENT + "%";
    } else {
      var styleVariable =
        100 / PROGRESS_BAR.STEP_COUNT_OTHER -
        PROGRESS_BAR.WIDTH_ADJUSTMENT +
        "%";
    }

    return (
      <>
        <ul id="progressbar">
          <li className="first active" style={{ width: styleVariable }}></li>
          <li
            className={
              values.step === STEPS.SECOND ||
              values.step === STEPS.THIRD ||
              values.step === STEPS.FOURTH ||
              values.step === STEPS.FIFTH
                ? "second active"
                : "second"
            }
            style={{ width: styleVariable }}
          ></li>
          <li
            className={
              values.step === STEPS.THIRD ||
              values.step === STEPS.FOURTH ||
              values.step === STEPS.FIFTH
                ? "third active"
                : "third"
            }
            style={{ width: styleVariable }}
          ></li>

          {values.status === STATUS.FOUND_ADVISOR ? (
            <li
              className={
                values.step === STEPS.FOURTH || values.step === STEPS.FIFTH
                  ? "fourth active"
                  : "fourth"
              }
              style={{ width: styleVariable }}
            ></li>
          ) : null}
        </ul>
      </>
    );
  }
}
